module.exports = __webpack_public_path__ + "static/media/male.defbcc4c.png";